import React, { PropTypes } from "react";
import GlobalConstants from "../../GlobalConstants";
import "./LinkTo.css";
import ReactGA from "react-ga";

class LinkTo extends React.Component {
  constructor(props) {
    super(props);

    this.brandSizeLink = this.brandSizeLink.bind(this);
    this.searchSizeString = this.searchSizeString.bind(this);
    this.baseURL = this.baseURL.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  baseURL() {
    return "https://www.amazon.com/s/?url=search-alias%3Dfashion";
  }

  searchSizeString() {
    if (this.props.size.amazonSearch !== undefined) {
      return this.props.size.amazonSearch;
    } else {
      return this.props.size.size;
    }
  }

  brandSizeLink() {
    if(this.props.brand.amazon === GlobalConstants.FILTER_AVAILABLE) {
      return `${this.baseURL()}&rh=n%3A7141123011%2Cn%3A7147444011%2Ck%3A${encodeURIComponent(this.searchSizeString())}%2Cp_89%3A${encodeURIComponent(this.props.brand.name)}${this.affiliateTag()}`;
    } else if(this.props.brand.amazon === GlobalConstants.FILTER_UNAVAILABLE){
      return `${this.baseURL()}&keywords="${encodeURIComponent(this.props.brand.name)}"+${encodeURIComponent(this.searchSizeString())}${this.affiliateTag()}`;
    } else {
      return false;
    }
  }

  affiliateTag() {
    if(process.env.REACT_APP_ENV === "production") {
      return "&tag=clothingsizer-20";
    }
    return "";
  }

  handleClick() {
    ReactGA.event({
      category: "Amazon",
      action: "Clicked Link",
      label: `${this.props.brand.name}:${this.props.size.size}`,
    });
  }

  render(){
    if(this.props.brand.amazon === GlobalConstants.BRAND_UNAVAILABLE) {
      return <p>Not on Amazon</p>;
    } else {
      return(
        <a className="pull-right btn btn-primary btn-sm amazon-link" href={this.brandSizeLink()} onClick={this.handleClick} target="_blank" rel="nofollow">
          {this.props.linkText}
        </a>
      );
    }
  }
}

LinkTo.propTypes = {
  size: PropTypes.shape({
    size: PropTypes.string.isRequired,
    amazonSearch: PropTypes.string,
  }),
  brand: PropTypes.shape({
    amazon: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  linkText: PropTypes.string.isRequired,
};

export default LinkTo;



/** WEBPACK FOOTER **
 ** ./src/components/Amazon/LinkTo/LinkTo.js
 **/